import { AI_API } from 'utils/globalApiServices';

export const getAssessmentsRating = async ({ org_id, submission_id }) => {
  const url = `/orgs/${org_id}/assessments/submissions/${submission_id}`;
  const { data } = await AI_API.get(url);
  return data?.answer_ratings || [];
};
